import styled from "styled-components";

export const ColumnWrapper = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  min-width: 300px;
  padding: 5px 10px;
  /* width: 100%; */
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  transition: background-color 0.3s ease;

  &:hover {
    cursor: pointer;
    background-color: #f0f0f0;
    border: 1px solid #d9d9d9;
  }

  ::-webkit-scrollbar {
    width: 0;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-track:hover {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgb(212, 212, 215);
    border-radius: 5px;
    width: 0;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgb(190, 190, 193);
  }

  &:hover {
    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-thumb {
      width: 2px;
    }
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  bottom: 30px;
  right: 40px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: white;
  color: #1677ff;
  font-size: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  }
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const SkeletonCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  background-color: #fff;
  width: 100%;
  min-height: 140px;
  max-height: 170px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .ant-skeleton-content .ant-skeleton-paragraph {
    margin-top: 12px;
  }

  .ant-skeleton-paragraph > li {
    height: 12px;
  }
`;

export const TicketList = styled.div<{ isGrid?: boolean; count?: number; fullHeight?: boolean }>`
  height: ${({ count, fullHeight }) => (fullHeight ? `calc(100% - 32px)` : !!count && count > 0 ? "fit-content" : `calc(100% - 32px)`)};
  padding: 0 5px 16px 0px;
  gap: 15px;
  display: ${(props) => (props.isGrid ? "grid" : "flex")};
  flex-direction: column;
  overflow-y: auto;

  ${(props) =>
    props.isGrid &&
    `   height: auto;
        max-height: calc(100dvh - 200px);
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-gap: 15px;
        @media (max-width: 700px) {
            max-height: calc(100dvh - 255px);
        }
    `}
`;
